import React, { useEffect } from "react";
import { Icon } from "./icons";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { closestKey } from "../utils/dom";
import { AutoFilterState } from "../hooks/useAutoFilter";

export function AutoFilterList(props: {
    filterID: string,
    data: any[] | undefined,
    onChange: (filter: AutoFilterState) => void,
}) {

    const { filterID, data } = props;

    const items = [];

    const [filterState, setFilterState] = useLocalStorage<AutoFilterState>(
        "auto_filter_" + filterID,
        { tags: [], search: "" }
    );

    // Migrate old format (plain string[]) to new shape
    const state = Array.isArray(filterState)
        ? { tags: filterState as unknown as string[], search: "" }
        : filterState;

    useEffect(() => {
        props.onChange(state);
    }, [filterState]);

    if (data && data.length > 0) {
        const counts = {} as any;

        for (let d of data) {
            if (!d.id) continue;

            const parts = d.id.split("-");
            for (let p of parts) {
                if (p.length < 3) continue;

                if (!counts[p]) {
                    counts[p] = 1;
                } else {
                    counts[p]++;
                }
            }
        }

        const threshold = 2;
        const unique: string[] = [];
        const highFreq = [];
        const veryHighFreq = [];
        for (let n in counts) {
            if (counts[n] < threshold) continue;
            unique.push(n);

            if (counts[n] >= 10 && veryHighFreq.indexOf(n) < 0) {
                veryHighFreq.push(n);
                continue;
            }

            if (counts[n] >= 5 && highFreq.indexOf(n) < 0) highFreq.push(n);
        }

        unique.sort();

        // clear any saved filter values that no longer exist in the available options
        const stale = state.tags.filter(f => unique.indexOf(f) < 0);
        if (stale.length > 0) {
            setFilterState({ ...state, tags: state.tags.filter(f => unique.indexOf(f) >= 0) });
        }

        for (let n of unique) {
            let cls = "tag interactive";

            if (state.tags.indexOf(n) >= 0) {
                cls += " primary";
            } else if (veryHighFreq.indexOf(n) >= 0) {
                cls += " recent-2";
            } else if (highFreq.indexOf(n) >= 0) {
                cls += " recent-1";
            }
            items.push(
                <div
                    key={n}
                    className={cls}
                    data-key={n}
                >{n}</div>
            );
        }
    }

    return (
        <div
            className="flex horiz gap-2 wrap"
            style={{ alignItems: "center" }}
            onClick={(e) => {
                const val = closestKey(e.target, ".tag");
                if (!val) return;
                const tags = [...state.tags];
                const i = tags.indexOf(val);
                if (i >= 0) {
                    tags.splice(i, 1);
                } else {
                    tags.push(val);
                }
                setFilterState({ ...state, tags });
            }}
        >
            <div className="tag" style={{ display: "flex", alignItems: "center", gap: 4, padding: "2px 6px" }}>
                <Icon type="search" size="tiny" />
                <input
                    value={state.search}
                    onChange={(e) => setFilterState({ ...state, search: e.target.value })}
                    style={{ border: "none", outline: "none", background: "transparent", width: 80, fontSize: "0.9em" }}
                    placeholder="search..."
                />
                {state.search && (
                    <span
                        style={{ cursor: "pointer", lineHeight: 1, opacity: 0.5 }}
                        onClick={(e) => { e.stopPropagation(); setFilterState({ ...state, search: "" }); }}
                    >×</span>
                )}
            </div>
            {items}
        </div>
    );
}
